<template>
  <div class="flex h-full flex-col gap-32">
    <h1 class="heading-1">{{ i18n(translations.title) }}</h1>
    <OpportunitiesFilters
      v-model:brand="brand"
      v-model:categories="categories"
      v-model:competition-levels="competitionLevels"
      v-model:grades="grades"
      v-model:market-codes="marketCodes"
      @reset="reset"
    />
    <OpportunitiesTable
      v-if="opportunities"
      v-model:ascending-input="ascending"
      v-model:order-by-input="orderBy"
      v-model:page-number-input="pageNumber"
      v-model:page-size-input="pageSize"
      :is-loading="status === 'pending'"
      :lastUpdatedAt="opportunities.lastUpdatedAt"
      :numberOfOpportunities="opportunities.totalCount"
      :opportunities="opportunities.sourcingOpportunities"
      :pageCount="opportunities.pageCount"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Opportunities.translations'
import OpportunitiesFilters from './components/OpportunitiesFilters.vue'
import OpportunitiesTable from './components/OpportunitiesTable.vue'
import { useFetchSourcingOpportunities } from './composables/useFetchSourcingOpportunities'

const {
  status,
  marketCodes,
  competitionLevels,
  brand,
  grades,
  categories,
  opportunities,
  pageSize,
  orderBy,
  ascending,
  pageNumber,
  reset,
} = useFetchSourcingOpportunities()
const i18n = useI18n()
</script>
